module.exports = __webpack_public_path__ + "static/mstile-310x150-1ca57815bc6a89a3debb3325b08b2cbf.png";